import Header from "@/components/feature/Header";
import HeroSection from "@/components/feature/HeroSection";
import AgeCategorySection from "@/components/feature/AgeCategorySection";
import CategorySection from "@/components/feature/CategorySection";
import RankingSection from "@/components/feature/RankingSection";
import GiftDiagnosisSection from "@/components/feature/GiftDiagnosisSection";
import ArticleSection from "@/components/feature/ArticleSection";
import EditorialPickSection from "@/components/feature/EditorialPickSection";
import SocialSection from "@/components/feature/SocialSection";
import Footer from "@/components/feature/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <AgeCategorySection />
        <CategorySection />

        {/* Ranking + Diagnosis Layout */}
        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="w-full px-4 md:px-6 lg:px-8">
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
              {/* Left: Ranking */}
              <div className="flex-1 min-w-0">
                <RankingSection />
              </div>
              {/* Right: Diagnosis */}
              <div className="w-full lg:w-80 xl:w-96 shrink-0">
                <GiftDiagnosisSection />
              </div>
            </div>
          </div>
        </section>

        <ArticleSection />
        <EditorialPickSection />
        <SocialSection />
      </main>
      <Footer />
    </div>
  );
}